import { render, staticRenderFns } from "./item-detail.vue?vue&type=template&id=16231e5e&scoped=true"
import script from "./item-detail.vue?vue&type=script&lang=js"
export * from "./item-detail.vue?vue&type=script&lang=js"
import style0 from "./item-detail.vue?vue&type=style&index=0&id=16231e5e&prod&scoped=true&lang=css"
import style1 from "./item-detail.vue?vue&type=style&index=1&id=16231e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16231e5e",
  null
  
)

export default component.exports